import { memo } from 'react';
import '@/components/Messenger/direct/DirectMessageBubble.css';
import { assistantUiTextFromParts } from '@/components/Messenger/agent/agentMessageRender/assistantUiText';
import type { TrackerChatMessage } from '@/components/Messenger/types/chatMessageTypes';

export type AgentSystemMessageRowProps = {
  message: TrackerChatMessage;
  timelineIso: string;
  animateEnter: boolean;
};

function AgentSystemMessageRowInner({ message, timelineIso, animateEnter }: AgentSystemMessageRowProps) {
  const text = assistantUiTextFromParts(message.parts) || 'Системное сообщение';
  return (
    <div
      className={[
        'directChatView__msgSlot',
        'directChatView__msgSlot_system',
        animateEnter ? 'messengerMsgEnter' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      data-agent-msg={message.id}
      data-timeline-iso={timelineIso}
    >
      <div className="directChatView__serviceMsg" role="status">
        <span className="directChatView__serviceMsgText">{text}</span>
      </div>
    </div>
  );
}

function arePropsEqual(a: AgentSystemMessageRowProps, b: AgentSystemMessageRowProps): boolean {
  return (
    a.message === b.message &&
    a.timelineIso === b.timelineIso &&
    a.animateEnter === b.animateEnter
  );
}

export const AgentSystemMessageRow = memo(AgentSystemMessageRowInner, arePropsEqual);
